module.exports = __webpack_public_path__ + "img/p1.2d138519.jpg";